var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router';
import Styles from './step-changed-styles.scss';
import { IconShieldCross, IconSmsNotification } from '@/presentation/components/icons';
import { loginFlowUserState } from '@/presentation/components';
import { useRecoilValue } from 'recoil';
const StepChanged = ({ addUser }) => {
    const navigate = useNavigate();
    const user = useRecoilValue(loginFlowUserState);
    const [state, setState] = useState({ sended: false });
    const handleResendInvitation = (event) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield addUser.resendInvitation(user.challengeParam.userAttributes.email);
            setState({ sended: true });
        }
        catch (error) {
            console.log('🚀 ~ file: step-changed.tsx:21 ~ handleToLogin ~ error:', error);
            setState({ sended: true });
        }
    });
    if (!user)
        return React.createElement(Navigate, { to: "/login", replace: true });
    if (!state.sended)
        return (React.createElement("div", { className: Styles.formClass },
            React.createElement("div", { className: Styles.mainPart },
                React.createElement("div", { className: Styles.mainIcon },
                    React.createElement(IconShieldCross, null)),
                React.createElement("div", { className: Styles.mainTitle },
                    React.createElement("div", { className: Styles.mainTitleLine1 }, "Invitation link has expired"),
                    React.createElement("div", { className: Styles.mainTitleLine2 }, "Use the button below to resend the invitation")),
                React.createElement("div", { className: Styles.backButton, onClick: handleResendInvitation },
                    React.createElement("div", { className: Styles.backButtonText }, "Resend Invite")))));
    if (state.sended)
        return (React.createElement("div", { className: Styles.formClass },
            React.createElement("div", { className: Styles.mainPart },
                React.createElement("div", { className: Styles.mainIconSuccess },
                    React.createElement(IconSmsNotification, null)),
                React.createElement("div", { className: Styles.mainTitle },
                    React.createElement("div", { className: Styles.mainTitleLine1 }, "Invitation link has been resent"),
                    React.createElement("div", { className: Styles.mainTitleLine2, style: { marginTop: '16px' } }, "Please check your email")))));
};
export default StepChanged;
